import { Dayjs } from "dayjs";

import {
  IFitbitActivityRequest,
  IFitbitActivityResponse,
  IFitbitSleepRequest,
  IFitbitSleepResponse,
} from "../@types/Fitbit";
import {
  ICompleteAuthorizationRequest,
  ICompleteAuthorizationResponse,
} from "../@types/OAuth";
import { ensureOk } from "../utils/ensureOk";
import { ANONYMOUS_REQUEST, api } from "./api";

const WALL_CLOCK_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const fitbitService = {
  async completeAuthorization(
    request: ICompleteAuthorizationRequest
  ): Promise<ICompleteAuthorizationResponse> {
    // Anonymous callback page (EN-5229): always the default API, never the
    // regional URL a previous sign-in left in browser storage.
    // ensureOk: the interceptor resolves errors (and `undefined` when nothing
    // came back), so without it the page would read an error body as success.
    return ensureOk(
      await api.post<ICompleteAuthorizationResponse>(
        "/Mobile/Fitbit/CompleteAuthorization",
        request,
        ANONYMOUS_REQUEST
      )
    );
  },

  async getPatientActivityData(
    patientId: number,
    fromDate: Dayjs,
    toDate: Dayjs
  ): Promise<IFitbitActivityResponse> {
    const request: IFitbitActivityRequest = {
      patientId,
      fromDate: fromDate.toISOString(),
      toDate: toDate.toISOString(),
    };
    const response = await api.post<IFitbitActivityResponse>(
      "/Portal/Wearable/PatientActivity",
      request
    );
    return response.data;
  },

  async getPatientSleepData(
    patientId: number,
    fromDate: Dayjs,
    toDate: Dayjs
  ): Promise<IFitbitSleepResponse> {
    const request: IFitbitSleepRequest = {
      patientId,
      fromDate: fromDate.format(WALL_CLOCK_FORMAT),
      toDate: toDate.format(WALL_CLOCK_FORMAT),
    };
    const response = await api.post<IFitbitSleepResponse>(
      "/Portal/Sleep/PatientSleep",
      request
    );
    return response.data;
  },
};
